'use strict';

import Backbone from 'backbone';

/**
 * Buying option
 *
 * @typedef {Object} BuyingOption
 * @property {string} availabilityMessage
 * @property {string} currentISOCurrency
 * @property {number} dateCode
 * @property {number} daysUntilDispatch
 * @property {string} dispatchDateMessage
 * @property {string} displayPipelineTotal
 * @property {string} displayQuantity
 * @property {boolean} hasUnitOfMeasure
 * @property {string} highestDisplayPrice
 * @property {number} highestPrice
 * @property {string} inventoryRegion
 * @property {string} lowestDisplayPrice
 * @property {number} lowestPrice
 * @property {?string} manufacturerLeadTime
 * @property {?*} manufacturerLeadTime
 * @property {string} manufacturerName
 * @property {number} orderIncrement
 * @property {number} orderMinimumQuantity
 * @property {?string} orderUrl
 * @property {string} packagingType
 * @property {string} packagingTypeTranslated
 * @property {string} partId
 * @property {string} partNumber
 * @property {?*} pipelineTotal
 * @property {Array} pipelines
 * @property {PriceBand[]} priceBands
 * @property {number} quantity
 * @property {string} shipsFromCountryName
 * @property {string} sourceCode
 * @property {string} sourcePartId
 * @property {string} type
 * @property {string} unitOfMeasure
 * @property {string} unitOfMeasureFormatted
 */

/**
 * Price band
 *
 * @typedef {Object} PriceBand
 * @property {string} displayPrice
 * @property {number} fromQuantity
 * @property {number} price
 * @property {number} toQuantity
 */

export default class BuyingOptionModel extends Backbone.Model {
  get idAttribute() {
    return 'sourcePartId';
  }

  // TODO: Create model/collection for priceBands?
  // TODO: Update jsdocs across the site to reference this
  // TODO: Update code across the site to use this
  defaults() {
    let defaults = {
      availabilityMessage: '',
      bestDeliveryDate: '',
      currentISOCurrency: '',
      dateCode: null,
      dispatchDateMessage: '',
      displayPipelineTotal: '',
      displayQuantity: '',
      estimatedDeliveryDate: '',
      hasUnitOfMeasure: false,
      highestDisplayPrice: '',
      highestPrice: 0,
      lowestDisplayPrice: '',
      lowestPrice: 0,
      manufacturerLeadTime: null,
      orderIncrement: 1,
      orderMinimumQuantity: 1,
      orderUrl: null,
      packagingType: '',
      packagingTypeTranslated: '',
      partId: '',
      partNumber: '',
      pipelineTotal: null,
      pipelines: [],
      priceBands: [],
      quantity: 0,
      shipsFromCountryName: '',
      sourceCode: '',
      sourcePartId: '',
      type: 'None',
      unitOfMeasureFormatted: '',
      manufacturerName: '',
      inventoryRegion: '',
      npi: ''
    };
    return defaults;
  }
}



// WEBPACK FOOTER //
// ./assets/components/BuyingOptions/BuyingOptionModel.js